import { render, staticRenderFns } from "./leftContent.vue?vue&type=template&id=2115af56"
import script from "./leftContent.vue?vue&type=script&lang=js"
export * from "./leftContent.vue?vue&type=script&lang=js"
import style0 from "./leftContent.vue?vue&type=style&index=0&id=2115af56&prod&lang=css"
import style1 from "./leftContent.vue?vue&type=style&index=1&id=2115af56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports